import { Injectable } from  '@angular/core';
import { HttpClient, HttpHeaders } from  '@angular/common/http';
import { Globals } from 'projects/shared/models/Globals';

@Injectable({
providedIn:  'root'
})

export  class  AppService {
       
    constructor(private  httpClient:  HttpClient) {
    }

    getAllMapPins(){
        return  this.httpClient.post(`${Globals.BaseUrl}/MapsWebAPI/GetAllMapPins`, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getFilteredMapItems(input){
        return  this.httpClient.post(`${Globals.BaseUrl}/MapsWebAPI/GetFilteredMapItems`,input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getFiltrationBoxLists(){
        return  this.httpClient.get(`${Globals.BaseUrl}/MapsWebAPI/GetFiltrationBoxLists`, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getTimelineDynasties(input){
        return  this.httpClient.post(`${Globals.BaseUrl}/MapsWebAPI/GetTimelineDynasties`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getEgyptianTreasureItemDetails(Id){
        return  this.httpClient.get(`${Globals.BaseUrl}/MapsWebAPI/GetEgyptianTreasureItemDetails?Id=${Id}`, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }
    
}
